module.exports = __webpack_public_path__ + "static/fetch-ruffcut-blackmuzzle-44a234bc9dbd4960dd7afe47c91b9976.mp4";